import { Button, Container, Image, Paper, Stack, Text, Title } from '@mantine/core';

// Shown by ProgramConfigGate when a portal's config cannot be loaded for a retryable reason (network
// error, 5xx). No config means no theme, so it uses the same plain layout as NotFoundPage.
export default function PortalUnavailablePage({ onRetry }: { onRetry: () => void }) {
  return (
    <Container size="sm" py="xl" className="portal-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Paper p="xl" radius="md" withBorder className="portal-panel" style={{ width: '100%' }}>
        <Stack align="center" gap="md">
          <Image src="/RIS_Rx_logo_digital_rgb_.png" alt="RIS Rx" maw={200} fit="contain" className="portal-header__logo" />
          <Title order={2} className="portal-section-title" ta="center">Something went wrong</Title>
          <Text size="sm" c="dimmed" ta="center">Please try again.</Text>
          <Button className="portal-primary-button" onClick={onRetry}>Try again</Button>
        </Stack>
      </Paper>
    </Container>
  );
}
